export default __webpack_public_path__ + "static/media/tkit-1.7d49445c.svg";